import { render, staticRenderFns } from "./giftPopup.vue?vue&type=template&id=3129eac2&scoped=true"
import script from "./giftPopup.vue?vue&type=script&lang=js"
export * from "./giftPopup.vue?vue&type=script&lang=js"
import style0 from "./giftPopup.vue?vue&type=style&index=0&id=3129eac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129eac2",
  null
  
)

export default component.exports